__turbopack_context__.v({
  "actions": "gN-auq_actions",
  "banner": "gN-auq_banner",
  "contact": "gN-auq_contact",
  "copy": "gN-auq_copy",
  "firstScreen": "gN-auq_firstScreen",
  "full": "gN-auq_full",
  "grain": "gN-auq_grain",
  "headline": "gN-auq_headline",
  "phones": "gN-auq_phones",
  "scene": "gN-auq_scene",
  "screenSlot": "gN-auq_screenSlot",
  "secondScreen": "gN-auq_secondScreen",
  "shade": "gN-auq_shade",
  "stage": "gN-auq_stage",
  "subtext": "gN-auq_subtext",
  "visual": "gN-auq_visual",
});
